'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutNotice = (_dec = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(CheckoutNotice, _React$Component);

  function CheckoutNotice() {
    (0, _classCallCheck3.default)(this, CheckoutNotice);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutNotice.__proto__ || (0, _getPrototypeOf2.default)(CheckoutNotice)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutNotice, [{
    key: 'hide',
    value: function hide() {
      this.props.close();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { styleName: 'overlay', onClick: this.props.close }),
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'header' },
            _react2.default.createElement(
              'div',
              { styleName: 'text' },
              'Important Notice \u2013 Bank Holiday Delivery'
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.hide.bind(this), styleName: 'closeButton' },
              _react2.default.createElement(_Icon2.default, { type: 'cross' })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'info' },
            _react2.default.createElement(
              'p',
              null,
              'All orders placed after midday on Thursday 9th April will be dispatched on Tuesday 14th April. This is due to the Bank Holiday delivery schedule.'
            )
          )
        )
      );
    }
  }]);
  return CheckoutNotice;
}(_react2.default.Component)) || _class);
exports.default = CheckoutNotice;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutNotice/index.js
// module id = 2454
// module chunks = 0